<div class="snack-content">
  @if (data.icon) {
    <mat-icon class="snack-icon" aria-hidden="true">{{ data.icon }}</mat-icon>
  }

  <div class="snack-message">{{ data.message }}</div>

  @if (data.action) {
    <button mat-button type="button" class="snack-action" (click)="onAction()">
      {{ data.action }}
    </button>
  }
</div>
